import { render, staticRenderFns } from "./spend_summary.vue?vue&type=template&id=2adcae2c&scoped=true&"
import script from "./spend_summary.vue?vue&type=script&lang=js&"
export * from "./spend_summary.vue?vue&type=script&lang=js&"
import style0 from "./spend_summary.vue?vue&type=style&index=0&id=2adcae2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adcae2c",
  null
  
)

export default component.exports